import { useState } from "react";
import cls from "classnames";
import toast from "react-hot-toast";
import { parseMarkdown } from "@qoohoo/common/utils/string";
import httpf from "utils/api/frontend/httpf";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import useEntityStore from "store/entityStore";
import Spinner from "../../../../common/library/loader/Spinner";
import Layout from "components/screens/Layout";
import {ButtonPrimary} from "../../../../common/components/library/Button";
import CrossIcon from "../icons/CrossIcon";

export default function PaymentTermsConsentForm({ onAccept, onReject }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [areTermsAccepted, setAreTermsAccepted] = useState(false);

  const entity = useEntityStore((state) => state.entity);
  const parsedPaymentTerms = parseMarkdown(entity.data.payment.consentTerms);

  const isButtonDisabled = !areTermsAccepted || isSubmitting;

  function toggleAcceptTerms() {
    setAreTermsAccepted(prev=>!prev);
  }

  async function handleOnAccept() {
    if (isButtonDisabled) {
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        accepted: true,
      };

      if (entity.isPremiumContent) {
        payload.premium_content = entity.data.uid;
      } else if (entity.isOneToOneMeeting) {
        payload.one_to_one_meeting = entity.data.uid;
      } else if(entity.isRegularChannel || entity.isCourse) {
        payload.channel = entity.data.uid;
      }

      await httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/log-payment-consent`, payload, {withCredentials: true});

      onAccept && onAccept();
    } catch (error) {
      console.error(error);

      toast.error("Something went wrong. Please try again!");

      throw error;
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="flex flex-col h-full w-full relative p-1 text-left">
      <div className="p-4 pb-0">
        <span className="font-semibold text-xl text-[#22272B] text-left">
          Terms
        </span>
        <button className="absolute right-4" onClick={onReject}>
          <CrossIcon />
        </button>
      </div>
      <Layout className="h-full overflow-auto">
        <div dangerouslySetInnerHTML={{__html: parsedPaymentTerms}} className="whitespace-normal list-marker"/>
        <div className="relative p-2 flex flex-col flex-auto w-full min-h-0 overflow-hidden">
        </div>
      </Layout>

      <div
        className="flex absolute bottom-0 pb-6 pt-2 px-4 w-full left-0 justify-end"
        style={{
          backgroundImage: 'linear-gradient(to top, #fff 70%, rgba(255,255,255,0.8))'
        }}
      >
        <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-4">
          <div className="sm:self-center w-fit max-w-full flex gap-2 items-center cursor-pointer" onClick={toggleAcceptTerms}>
            <input className="accent-primary outline-none h-4 w-4 cursor-pointer" type="checkbox" checked={areTermsAccepted}/>
            <span className="text-[#16191B] select-none text-[0.8125rem] sm:text-sm leading-5">I have read and agree to the terms</span>
          </div>
          <ButtonPrimary
            className="w-full sm:max-w-[180px] bg-primary"
            disabled={isButtonDisabled}
            onClick={handleOnAccept}
            doOpacityForDisabled
          >
            <span>Continue</span>
            {isSubmitting && <Spinner className="!h-5 !w-5 ml-3" />}
          </ButtonPrimary>
        </div>
      </div>

    </div>
  );
}
